import { AmplifyAuthenticator } from '@aws-amplify/ui-react'
import { Auth } from 'aws-amplify'
import axios from "axios"
import { useEffect, useState } from 'react'
import { CommonLoading } from 'react-loadingg'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './App.scss'
import { AddBulletin, EditBulletin, ViewBulletin } from './components/Bulletin'
import IdleTimeOutContainer from './components/IdleTimeOut/IdleTimeOutContainer'
import UserDetail from './components/UserDetail/UserDetail'
import { CreateUser, Permission, ResetUser, ManagePayrollPic } from "./components/Settings"
import Sidebar from './components/Sidebar/Sidebar'
import HRConnectLogo from './images/hrconnect-logo.svg'
import LoginBtn from './images/login-btn.svg'
import TGLogo from './images/tg-logo.svg'
import BulletinBoard from './pages/BulletinBoard'
import Home from './pages/Home'
import InfoHub from './pages/InfoHub'
import InfoHubCategory from './pages/InfoHubCategory'
import NotFound from './pages/NotFound'
import AllReport from './pages/AllReport'
import Settings from './pages/Settings'
import { QREvent } from './components/QREvent'
import Grievance from './pages/Grievance'
import GrievanceForm from './components/Grievance/GrievanceForm'
import GrievanceReport from './components/GrievanceReport/GrievanceReport'
import GrievancePermission from './components/GrievanceSetting/GrievancePermission'
import ResignationForm from './components/Resignation/ResignationForm'
import Resignation from './components/Resignation/Resignation'
import HodCommentForm from './components/Resignation/HodCommentForm'
import HodCommentFormReport from './components/HodCommentFormReport/HodCommentFormReport'

const App = () => {
  const [username, setUserName] = useState('')
  const [badgeID, setBadgeID] = useState()
  const [loginList, setLoginList] = useState([])
  const [grievancePermission, setGrievancePermission] = useState([])
  const [isActive, setIsActive] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [cognitoToken, setCognitoToken] = useState();
  const { REACT_APP_AWS_REDIRECT_URL, REACT_APP_API_BACKEND_URL } = process.env;

  useEffect(() => {
    async function checkUser() {
      try {
        const activeSession = sessionStorage.activeSession;

        if (sessionStorage.loggedOutOnAuth) {
          // console.log('Logged out due to expiry already')
        }
        else if (!activeSession) {
          sessionStorage.loggedOutOnAuth = true;
          signOut();
        }

        const cognitoUser = await Auth.currentAuthenticatedUser();
        // console.log('user info: ', cognitoUser)
        const cognitoToken = await Auth.currentSession();
        setCognitoToken(cognitoToken)
        console.log(cognitoToken)
        if (cognitoUser.attributes["custom:badgeID"]) {
          const url = REACT_APP_API_BACKEND_URL + '/api/loginauth'

          setBadgeID(cognitoUser.attributes["custom:badgeID"])

          axios.post(url, { userID: cognitoUser.attributes["custom:badgeID"] })
            .then((response) => {

              setLoginList(response.data.LoginList);
              setGrievancePermission(response.data.grievance);
              setIsLoading(false);
              sessionStorage.setItem('activeSession', 'true');

              if (response.data.errCode === 'R01') {
                window.stop();
                alert('You have no access to this site, please contact the system administrator.');
                signOut();
              }
            })
            .catch((error) => {
              console.log(error)
            });
        } else {
          alert('You have no access to this site, please contact the system administrator.');
          signOut();
        }

        if (cognitoUser) {
          const userName = cognitoUser.attributes["name"].replace(/ *\([^)]*\) */g, "");
          localStorage.setItem('username', userName);
          setUserName(userName);

          const email = cognitoUser.username.split('_')[1];
          localStorage.setItem('email', email);

          const badgeID = cognitoUser.attributes["custom:badgeID"];
          localStorage.setItem('badgeID', badgeID);
        }

      } catch (err) {
        console.log('user is not logged in', err)
      }
    }

    checkUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function signOut() {
    try {
      await Auth.signOut();
      sessionStorage.setItem('activeSession', 'false');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (
    <AmplifyAuthenticator>
      <div className='login-form-container' slot='sign-in'>
        <div className='logo-wrapper'>
          <img src={TGLogo} style={{ width: '20rem' }} alt='' />
        </div>
        <div className='login-form-wrapper'>
          <img src={HRConnectLogo} style={{ width: '200px' }} alt='' />
          <a href={REACT_APP_AWS_REDIRECT_URL} className='login-btn' style={{ marginTop: '4%' }}>
            <div className='zoomout'>
              <img src={LoginBtn} alt='' />
            </div>
          </a>
        </div>
      </div>
      {isLoading ?
        <CommonLoading />
        :
        <BrowserRouter>
          {/* <BrowserRouter basename='/hrca'> */}
          <Sidebar isActive={isActive} setIsActive={setIsActive} username={username} loginList={loginList} grievancePermission={grievancePermission} />
          <IdleTimeOutContainer logOut={signOut} />
          <Switch>
            <Route exact path='/' render={(props) => <Home {...props} username={username} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} />} />
            <Route exact path='/bulletinboard' render={(props) => <BulletinBoard {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/bulletinboard/create' render={(props) => <AddBulletin {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/bulletinboard/view/:id' render={(props) => <ViewBulletin {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/bulletinboard/edit/:id' render={(props) => <EditBulletin {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/infohub' render={(props) => <InfoHub {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/infohub/folder' render={(props) => <InfoHubCategory {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/reports' render={(props) => <AllReport {...props} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} />} />
            <Route exact path='/reports/userdetails' render={(props) => <UserDetail {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/reports/qrevents' render={(props) => <QREvent {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/reports/grievance' render={(props) => <GrievanceReport {...props} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} />} />
            <Route exact path='/reports/hodCommentForm' render={(props) => <HodCommentFormReport {...props} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} cognitoToken={cognitoToken} />} />
            <Route exact path='/settings' render={(props) => <Settings {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/settings/manageuser/setpermission' render={(props) => <Permission {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/settings/manageuser/managebusdriver' render={(props) => <CreateUser {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/settings/manageuser/resetuser' render={(props) => <ResetUser {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/settings/manageuser/managepayrollpic' render={(props) => <ManagePayrollPic {...props} loginList={loginList} isActive={isActive} cognitoToken={cognitoToken} />} />
            <Route exact path='/settings/grievance/permission' render={(props) => <GrievancePermission {...props} loginList={loginList} isActive={isActive} />} />
            <Route exact path='/grievance' render={(props) => <Grievance {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} />} />
            <Route exact path='/grievance/grievanceform/:id' render={(props) => <GrievanceForm {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} grievancePermission={grievancePermission} />} />
            <Route exact path='/resignation' render={(props) => <Resignation {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} cognitoToken={cognitoToken} />} />
            <Route exact path='/resignation/resignationform' render={(props) => <ResignationForm {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} cognitoToken={cognitoToken} />} />
            <Route exact path='/resignation/hodcommentForm' render={(props) => <HodCommentForm {...props} badgeID={badgeID} loginList={loginList} isActive={isActive} cognitoToken={cognitoToken} username={username} />} />
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      }
    </AmplifyAuthenticator>
  )
}

export default App
